import { COLORS } from 'helpers/globals'

const rightArrow = {
  color: COLORS.primary,
  fontSize: '2rem',
  margin: 'auto',
  flex: '0 0 6.1rem'
}

export default {
  projectList: {
    background: 'white',
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    background: COLORS.primary,
    color: 'white',
    textAlign: 'center',
    fontSize: '2rem',
    fontWeight: '500'
  },
  searchWrapper: {
    padding: '.5rem',
    position: 'relative'
  },
  searchInput: {
    paddingLeft: '2.5rem !important'
  },
  searchIcon: {
    position: 'absolute',
    left: '1rem',
    top: '1.1rem'
  },
  projectsWrapper: {
    overflowY: 'auto',
    paddingTop: '1rem',
    '&:after': {
      position: 'absolute',
      bottom: 0,
      height: '5rem',
      width: '100%',
      content: '""',
      background: 'linear-gradient(to top, rgba(255,255,255, 1), rgba(255,255,255, 0))'
    }
  },
  row: {
    display: 'flex',
    padding: '0.5rem 0 0.5rem 1.5rem',
    '&:nth-of-type(even)': {
      background: COLORS.tertiary
    },
    '&:last-of-type': {
      marginBottom: '3rem'
    }
  },
  info: {
    display: 'flex',
    marginTop: '0.5rem',
    color: '#86929C',
    fontSize: '1.4rem',
    '& span': {
      flex: '1 1 50%'
    }
  },
  rightArrow,
  whiteArrow: {
    ...rightArrow,
    color: 'white',
    marginLeft: '1.5rem'
  },
  notFoundText: {
    marginLeft: '1.5rem',
    marginBottom: '1.5rem'
  },
  newProjectButton: {
    color: 'white',
    borderRadius: 10,
    padding: '.75rem 1.5rem',
    width: '75%',
    margin: 'auto',
    border: `1px solid ${COLORS.secondary}`,
    background: COLORS.primary
  },
  loading: {
    margin: 'auto',
    textAlign: 'center',
    fontSize: '3rem',
    color: 'white',
    fontWeight: '400',
    display: 'flex',
    flexDirection: 'column'
  },
  locationButton: {
    margin: 'auto auto 1rem auto',
    fontSize: '4rem'
  },
  loadingButton: {
    margin: 'auto',
    fontSize: '4rem',
    color: COLORS.secondary
  }
}



// WEBPACK FOOTER //
// ./src/components/MobileStart/ProjectList/style.js